import { CommonModule } from '@angular/common'; // Importa CommonModule
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';

interface Evaluacion {
  id_evaluacion: number;
  nombre: string;
  preguntas: Array<{
    id_pregunta: number;
    alternativas: Array<{
      id_alternativa: number;
      correcta: number; // 1 para correcta, 0 para incorrecta
    }>;
  }>;
}

interface ResultadoEvaluacion {
  id_resultado_evaluacion: number;
  calificacion: number;
  nivel_alcanzado: string;
  fecha_evaluacion: string;
}

interface RespuestaEstudiante {
  id_respuesta_estudiante: number;
  correcto: number; // 1 para correcta, 0 para incorrecta
  pregunta: {
    id_pregunta: number;
  };
  alternativa: {
    id_alternativa: number;
    correcta: number; // 1 para correcta, 0 para incorrecta
  };
}

@Component({
  selector: 'app-historial-evaluacion-estudiante',
  standalone: true, // Si estás usando standalone components
  imports: [CommonModule], // Añade CommonModule aquí
  templateUrl: './historial-evaluacion-estudiante.component.html',
  styleUrls: ['./historial-evaluacion-estudiante.component.css'],
})
export class HistorialEvaluacionEstudianteComponent {
  id_evaluacion!: number;
  id_resultado_evaluacion!: number;
  evaluacion!: Evaluacion;
  resultadoEvaluacion!: ResultadoEvaluacion;
  respuestasEstudiante: RespuestaEstudiante[] = [];
  preguntasConRespuestas: any[] = []; // Aquí almacenaremos las preguntas con las respuestas del estudiante

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.id_evaluacion = params['id_evaluacion'];
      this.id_resultado_evaluacion = params['id_resultado_evaluacion'];
    });

    this.obtenerEvaluacion();
    this.obtenerResultadoEvaluacion();
    this.obtenerRespuestasEstudiante();
  }

  volver(): void {
    this.router.navigate(['/historial-evaluacion'], {
      queryParams: { id_evaluacion: this.id_evaluacion },
    });
  }
  //TODO Historial Evaluacion
  obtenerEvaluacion() {
    this.http
      .get<Evaluacion>(`${environment.apiUrl}/evaluacion/${this.id_evaluacion}`)
      .subscribe(
        (response) => {
          this.evaluacion = response;
          this.combinarDatos(); // Combinar datos después de obtener la evaluación
        },
        (error) => {
          console.error('Error al obtener la evaluación:', error);
        }
      );
  }

  obtenerResultadoEvaluacion() {
    this.http
      .get<ResultadoEvaluacion>(
        `${environment.apiUrl}/resultado-evaluacion/${this.id_resultado_evaluacion}`
      )
      .subscribe(
        (response) => {
          this.resultadoEvaluacion = response;
        },
        (error) => {
          console.error(
            'Error al obtener el resultado de la evaluación:',
            error
          );
        }
      );
  }

  obtenerRespuestasEstudiante() {
    this.http
      .get<RespuestaEstudiante[]>(
        `${environment.apiUrl}/respuesta-estudiante?id_resultado_evaluacion=${this.id_resultado_evaluacion}`
      )
      .subscribe(
        (response) => {
          this.respuestasEstudiante = response;
          this.combinarDatos(); // Combinar datos después de obtener las respuestas
        },
        (error) => {
          console.error(
            'Error al obtener las respuestas del estudiante:',
            error
          );
        }
      );
  }

  combinarDatos() {
    if (this.evaluacion && this.respuestasEstudiante.length > 0) {
      this.preguntasConRespuestas = this.evaluacion.preguntas.map(
        (pregunta) => {
          const respuestaEstudiante = this.respuestasEstudiante.find(
            (respuesta) =>
              respuesta.pregunta.id_pregunta === pregunta.id_pregunta
          );

          // Determinar el estado de la respuesta del estudiante
          let estadoRespuesta = 'no-respondida'; // Por defecto, no respondida
          if (respuestaEstudiante) {
            estadoRespuesta =
              respuestaEstudiante.correcto === 1 ? 'correcta' : 'incorrecta';
          }

          return {
            ...pregunta,
            respuestaEstudiante: respuestaEstudiante
              ? {
                  id_alternativa:
                    respuestaEstudiante.alternativa.id_alternativa,
                  correcta: respuestaEstudiante.alternativa.correcta,
                  correcto: respuestaEstudiante.correcto,
                }
              : null,
            estadoRespuesta: estadoRespuesta, // Añadir el estado de la respuesta
          };
        }
      );
    }
  }

  obtenerLetraAlternativa(index: number): string {
    // Convertir el índice a su correspondiente letra (0 -> a, 1 -> b, etc.)
    return String.fromCharCode(97 + index); // 97 es el código ASCII para 'a'
  }
}
